<template>
  <div class="w-table-wrap" style="max-height: 1400px;">
    <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @validate="onValidate" @success="onSuccess()" >
      <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" >
         <template #title>
            CAJ PERKHIDMATAN ET
            <w-flex justify-end class="mt2">
               <w-button @click="isMinimizedCaj = !isMinimizedCaj">
                  <template v-if="isMinimizedCaj">
                     <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                  </template>
                  <template v-else>
                     <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                  </template>
               </w-button>
            </w-flex>
         </template>
         <div v-show="!isMinimizedCaj">
         <br>
            <figure class="table-aims">
                <figure class="table">
                    <table class="w-table">
                      
                          <tbody>
                              <tr>
                                  <td colspan="3"><strong>Tarikh / Perkhidmatan</strong></td>
                                  <td width="1px">:</td>
                                  <td colspan="2">{{$zutil.dateformat(datas.tarikh_ai)}}</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                              </tr>
                              <tr>
                                  <td width="1px"><b>1.</b></td>
                                  <td colspan="2"><strong>Konsultasi / Perkhidmatan</strong></td>
                                  <td>:</td>
                                  <td>
                                                <w-tag
                                                  class="mr4"
                                                  bg-color="primary"
                                                  round>
                                                   <template v-if="datas.konsutasi_ya_tidak==1">Berbayar</template><template v-else>Subsidi</template>
                                                </w-tag>
                                  </td>
                                  <td align="right"></td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td colspan="2" align="right">
                                      RM {{$zutil.formatDecimal(datas.konsutasi)}}
                                  </td>
                              </tr>
                              <tr>
                                  <td><b>2.</b></td>
                                  <td colspan="2"><strong>Harga Embrio</strong></td>
                                  <td colspan="2"><strong>ID Ternakan | No Batch</strong></td>
                                  <td><strong>Harga (RM)</strong></td>
                                  <td>&nbsp;</td>
                                  <td><strong>Kuantiti</strong></td>
                                  <td colspan="2"><strong>Jumlah (RM)</strong></td>
                              </tr>
                              <tr>
                                  <td>&nbsp;</td>
                                  <td width="1px" class="text-center">i.</td>
                                  <td>Embrio Subsidi Jabatan (IBVK)</td>
                                  <td></td>
                                  <td>
                                       <div v-if="ibvk.length ==0">-</div>
                                          <div v-for="stock in ibvk" v-else>
                                          {{stock.no_batch_keterangan}}
                                       </div>
                                  </td>
                                  <td align="right">
                                       <div v-if="ibvk.length ==0">-</div>
                                          <div v-for="stock in ibvk" v-else>
                                          {{$zutil.formatDecimal(stock.harga)}}
                                       </div>
                                  </td>
                                  <td>&nbsp;</td>
                                  <td>
                                       <div v-if="ibvk.length ==0">-</div>
                                          <div v-for="stock in ibvk" v-else>
                                          {{stock.kuantiti}}
                                       </div>
                                  </td>
                                  <td colspan="2" align="right">
                                       <div v-if="ibvk.length ==0">-</div>
                                          <div v-for="stock in ibvk" v-else>
                                          {{$zutil.formatDecimal(stock.total_harga)}}
                                       </div>
                                  </td>
                              </tr>
                              <tr>
                                  <td>&nbsp;</td>
                                  <td width="1px" class="text-center">ii.</td>
                                  <td>Embrio Subsidi Jabatan (Negeri)</td>
                                  <td>&nbsp;</td>
                                  <td>
                                       <div v-if="negri.length ==0">-</div>
                                          <div v-for="stock in negri" v-else>
                                          {{stock.no_batch_keterangan}}
                                       </div>
                                  </td>
                                  <td align="right">
                                       <div v-if="negri.length ==0">-</div>
                                          <div v-for="stock in negri" v-else>
                                          {{$zutil.formatDecimal(stock.harga)}}
                                       </div>
                                  </td>
                                  <td>&nbsp;</td>
                                  <td>
                                       <div v-if="negri.length ==0">-</div>
                                          <div v-for="stock in negri" v-else>
                                          {{stock.kuantiti}}
                                       </div>
                                  </td>
                                  <td colspan="2" align="right">
                                       <div v-if="negri.length ==0">-</div>
                                          <div v-for="stock in negri" v-else>
                                          {{$zutil.formatDecimal(stock.total_harga)}}
                                       </div>
                                  </td>
                              </tr>
                              <tr>
                                  <td>&nbsp;</td>
                                  <td width="1px" class="text-center">iii.</td>
                                  <td>Embrio Persendirian</td>
                                  <td>&nbsp;</td>
                                  <td>
                                    <div v-if="persendirian.length ==0">-</div>
                                             <div v-for="stock in persendirian" v-else>
                                            {{stock.no_batch_keterangan}}
                                            </div>
                                    </td>
                                  <td align="right">
                                     <div v-if="persendirian.length ==0">-</div>
                                          <div v-for="stock in persendirian" v-else>
                                          {{$zutil.formatDecimal(stock.harga)}}
                                    </div>
                                  </td>
                                  <td>&nbsp;</td>
                                  <td><div v-if="persendirian.length ==0">-</div>
                                          <div v-for="stock in persendirian" v-else>
                                          {{stock.kuantiti}}
                                       </div>
                                    </td>
                                  <td colspan="2" align="right">
                                     <div v-if="persendirian.length ==0">-</div>
                                          <div v-for="stock in persendirian" v-else>
                                          {{$zutil.formatDecimal(stock.total_harga)}}
                                       </div>
                                  </td>
                              </tr>
                              <tr>
                                  <td><b>3.</b></td>
                                  <td colspan="2"><strong>Caj Perjalanan (RM)</strong></td>
                                  <td>:</td>
                                  <td align="left">
                                        <w-tag
                                               class="mr4"
                                               bg-color="primary"
                                               round>
                                                <template v-if="datas.bayar_pengangkutan==1">Berbayar</template><template v-else>Subsidi</template>
                                        </w-tag>
                                      
                                  </td>
                                  <td align="right"></td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td colspan="2" align="right">RM {{$zutil.formatDecimal(datas.pengangkutan)}}</td>
                              </tr>
                              <tr>
                                  <td><b>4.</b></td>
                                  <td colspan="2"><strong>Caj Lain-Lain (Jika Ada)(RM)</strong></td>
                                  <td>:</td>
                                  <td align="left">
                                        <w-tag
                                               class="mr4"
                                               bg-color="primary"
                                               round>
                                                <template v-if="datas.bayar_caj_lain==1">Berbayar</template><template v-else>Subsidi</template>
                                        </w-tag>
                                   </td>
                                  <td align="right"></td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td colspan="2" align="right">RM {{$zutil.formatDecimal(datas.caj_lain)}}</td>
                              </tr>
                              <tr>
                                  <td>&nbsp;</td>
                                  <td colspan="2">Nyatakan</td>
                                  <td>:</td>
                                  <td><template v-if="datas.nyatakan==null">-</template>
                                       <template v-else>{{datas.nyatakan}}</template>
                                  </td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                              </tr>
                              <tr>
                                  <td colspan="3">&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                              </tr>
                              <tr>
                                  <td colspan="3">&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                              </tr>
                              <tr>
                                  <td colspan="3"><strong>Jumlah Caj Keseluruhan</strong></td>
                                  <td>:</td>
                                  <td colspan="2" align="left"><strong>RM {{$zutil.formatDecimal(datas.keseluruhan)}}</strong></td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                              </tr>
                              <tr>
                                  <td colspan="3"><strong>Jumlah Caj Subsidi Kerajaan</strong></td>
                                  <td>:&nbsp;</td>
                                  <td colspan="2" align="left"><strong>RM {{$zutil.formatDecimal(datas.subsidi)}}</strong></td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                              </tr>
                              <tr>
                                  <td colspan="3"><strong>Jumlah Caj Yang Perlu Dibayar</strong></td>
                                  <td>:</td>
                                  <td colspan="2" align="left"><strong>RM {{$zutil.formatDecimal(datas.perlu_bayar)}}</strong></td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                              </tr>
                          </tbody>
                      
                    </table>
                </figure>
            </figure>
         </div>
      </w-card>
      <br>
      <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'CAJ PERKHIDMATAN KEBUNTINGAN ET'" v-if="datas.tarikh_pemeriksaan_art!=null">
         <template #title>
            CAJ PERKHIDMATAN KEBUNTINGAN ET
            <w-flex justify-end class="mt2">
               <w-button @click="isMinimizedCajKeb = !isMinimizedCajKeb">
                  <template v-if="isMinimizedCajKeb">
                     <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                  </template>
                  <template v-else>
                     <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                  </template>
               </w-button>
            </w-flex>
         </template>
      <div v-show="!isMinimizedCajKeb">
         <figure class="table-aims">
             <figure class="table">
                 <table class="w-table">
                   
                       <tbody>
                           <tr>
                               <td colspan="3"><strong>Tarikh / Perkhidmatan</strong></td>
                               <td width="1px">:</td>
                               <td colspan="2">{{$zutil.dateformat(datas.tarikh_pemeriksaan_art)}}</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                           </tr>
                           <tr>
                               <td width="1px"><b>1.</b></td>
                               <td colspan="2"><strong>Konsultasi / Perkhidmatan</strong></td>
                               <td>:</td>
                               <td colspan="2">
                                             <w-tag
                                               class="mr4"
                                               bg-color="primary"
                                               round>
                                                <template v-if="datas.konsutasi_pemeriksaan_ya_tidak==1">Berbayar</template><template v-else>Subsidi</template>
                                             </w-tag>
                                             RM {{$zutil.formatDecimal(datas.konsutasi_pemeriksaan)}}</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                           </tr>                                       
                           <tr>
                               <td><b>2.</b></td>
                               <td colspan="2"><strong>Caj Pemeriksaan PD (RM)</strong></td>
                               <td>:</td>
                               <td colspan="2" align="left">
                                 <w-tag
                                        class="mr4"
                                        bg-color="primary"
                                        round>
                                        <template v-if="datas.bayar_pemeriksaan_pd==1">Berbayar</template><template v-else>Subsidi</template>
                                    </w-tag>
                                    RM {{$zutil.formatDecimal(datas.caj_pemeriksaan_pd)}}
                                </td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>
                               <td><b>3.</b></td>
                               <td colspan="2"><strong>Caj Perjalanan (RM)</strong></td>
                               <td>:</td>
                               <td colspan="2" align="left">
                                    <w-tag
                                        class="mr4"
                                        bg-color="primary"
                                        round>
                                        <template v-if="datas.bayar_pengangkutan_pemeriksaan==1">Berbayar</template><template v-else>Subsidi</template>
                                    </w-tag>
                                    RM {{$zutil.formatDecimal(datas.pengangkutan_pemeriksaan)}}
                                </td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                           </tr>
                           <tr>
                               <td><b>4.</b></td>
                               <td colspan="2"><strong>Caj Lain-Lain (Jika Ada) (RM)</strong></td>
                               <td>:</td>
                               <td colspan="2" align="left">
                                    <w-tag
                                        class="mr4"
                                        bg-color="primary"
                                        round>
                                        <template v-if="datas.bayar_caj_lain_pemeriksaan==1">Berbayar</template><template v-else>Subsidi</template>
                                    </w-tag>
                                    RM {{$zutil.formatDecimal(datas.caj_lain_pemeriksaan)}}
                                </td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                           </tr>
                           <tr>
                               <td>&nbsp;</td>
                               <td colspan="2">Nyatakan</td>
                               <td>:</td>
                               <td><template v-if="datas.nyatakan_pemeriksaan==null">-</template>
                                    <template v-else>{{datas.nyatakan_pemeriksaan}}</template>
                                </td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                           </tr>
                           <tr>
                               <td colspan="3">&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                           </tr>
                           <tr>
                               <td colspan="3">&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                           </tr>
                           <tr>
                               <td colspan="3"><strong>Jumlah Caj Keseluruhan</strong></td>
                               <td>:</td>
                               <td colspan="2" align="left"><strong>RM {{$zutil.formatDecimal(datas.keseluruhan_pemeriksaan)}}</strong></td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                           </tr>
                           <tr>
                               <td colspan="3"><strong>Jumlah Caj Yang Perlu Dibayar</strong></td>
                               <td>:</td>
                               <td colspan="2" align="left"><strong>RM {{$zutil.formatDecimal(datas.perlu_bayar_pemeriksaan)}}</strong></td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                           </tr>
                           <tr>
                               <td colspan="3"><strong>Jumlah Caj Subsidi Kerajaan</strong></td>
                               <td>:&nbsp;</td>
                               <td colspan="2" align="left"><strong>RM {{$zutil.formatDecimal(datas.subsidi_pemeriksaan)}}</strong></td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                               <td>&nbsp;</td>
                           </tr>
                       </tbody>
                   
                 </table>
             </figure>
         </figure>
      </div>
      </w-card>
        <w-flex class="mt3" wrap align-center justify-end v-if="(datas.lkp_status_id==34 || datas.lkp_status_id==27) && datas.tarikh_pemeriksaan_art==null">
          &nbsp;
         <!--  <w-button class="my1" bg-color="success" type="submit" @click="validateForm(35)" :disabled="loading" :loading="loading">
            <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
          </w-button> -->
           <w-button class="my1" bg-color="success" type="submit" @click="validateForm(39)" :disabled="loading" :loading="loading">
            <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
          </w-button>
        </w-flex>
        <w-flex class="mt3" wrap align-center justify-end v-if="datas.tarikh_pemeriksaan_art!=null && (datas.lkp_status_id==27 || datas.lkp_status_id==34 || datas.lkp_status_id==39)">
          &nbsp;
          <!-- <w-button class="my1" bg-color="success" type="submit" @click="validateForm(35)" :disabled="loading" :loading="loading">
            <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
          </w-button> -->
          <w-button class="my1" bg-color="success" type="submit" @click="validateForm(40)" :disabled="loading" :loading="loading">
            <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
          </w-button>
        </w-flex>
    </w-form>
  </div>
</template>

<script>
export default {
  name: "Pemilik",
  props:{
    d_data: [Array, Object],
    d_segmenName: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'art.semakan.et-aiman',
      form : {},
      datas : this.d_data,
      lkp_berahi : [],
      loading:false,
      ternakan_list:[],
      list_stock:[],

      skorbadanlist:[
        {value: 1, label: "1"},
        {value: 2, label: "2"},
        {value: 3, label: "3"},
        {value: 4, label: "4"},
        {value: 5, label: "5"}
      ],
      validators: {
          required: (value) => value !== null && value !== undefined && value !== '' || "Medan ini wajib diisi",
          consent: (value) => !!value || "You must agree",
          email: (value) =>
              !!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i) ||
              "Sila Semak Format Email",
          numeric: (value) => !isNaN(value) || "Medan Ini Wajib Numeric",
      },
      kategori_semen:[],
      isMinimizedCaj: false,
      lkp_baka:[],
      negri:[],
      ibvk:[],
      ternakan_list:[],
      persendirian: [],
      
    }
  },
  methods:{
   getTernakan(){
      // ternakan list
      for (var b in this.datas.ternakan_list) {
        if(this.datas.ternakan_list[b].status_pemeriksaan==1){
          this.ternakan_list.push({
            id:this.datas.ternakan_list[b].id,
            art_id:this.datas.ternakan_list[b].art_id,
            bil_straw:this.datas.ternakan_list[b].bil_straw,
            bunting:this.datas.ternakan_list[b].bunting,
            harga_straw:this.datas.ternakan_list[b].harga_straw,
            id_ternakan:this.datas.ternakan_list[b].id_ternakan,
            jankaan_kelahiran:this.datas.ternakan_list[b].jankaan_kelahiran,
            lkpBerahi_keterangan:this.datas.ternakan_list[b].lkpBerahi_keterangan,
            lkp_berahi_id:this.datas.ternakan_list[b].lkp_berahi_id,
            no_kes:this.datas.ternakan_list[b].no_kes,
            se_stock_id:this.datas.ternakan_list[b].se_stock_id,
            skor_badan:this.datas.ternakan_list[b].skor_badan,
            status:this.datas.ternakan_list[b].status,
            ternakan_id:this.datas.ternakan_list[b].ternakan_id,
            usia_bunting:this.datas.ternakan_list[b].usia_bunting,
            usia_bunting:this.datas.ternakan_list[b].usia_bunting,
            list_stock: this.datas.ternakan_list[b].list_stock,
            max_kuantiti_straw:this.datas.ternakan_list[b].max_kuantiti_straw,
            no_batch_keterangan:this.datas.ternakan_list[b].no_batch_keterangan,
            lkp_penentuan_ai_id:this.datas.ternakan_list[b].lkp_penentuan_ai_id,
            ternakan_nama:this.datas.ternakan_list[b].ternakan_nama,
            lkp_kategori_semen_id: this.datas.ternakan_list[b].lkp_kategori_semen_id,
            tarikh_beranak_terdahulu : this.datas.ternakan_list[b].tarikh_beranak_terdahulu,
            baka : this.datas.ternakan_list[b].baka,
            lkpKaedahPemeriksaan_keterangan: this.datas.ternakan_list[b].lkpKaedahPemeriksaan_keterangan,
            lkp_kaedah_pemeriksaan_id: this.datas.ternakan_list[b].lkp_kaedah_pemeriksaan_id,
            bunting_art: this.datas.ternakan_list[b].bunting_art,
            usia_bunting_art: this.datas.ternakan_list[b].usia_bunting_art,
            jankaan_kelahiran_art: this.datas.ternakan_list[b].jankaan_kelahiran_art,
            lkp_status_kesihatan_id: this.datas.ternakan_list[b].lkp_status_kesihatan_id,
            skor_badan: this.datas.ternakan_list[b].skor_badan,
            jankaan_biang_semula : this.datas.ternakan_list[b].jankaan_biang_semula,
            no_batch: this.datas.ternakan_list[b].no_batch,
            id_ternakan_batch: this.datas.ternakan_list[b].id_ternakan_batch,
            id_ternakan_betina: this.datas.ternakan_list[b].id_ternakan_betina,
          })
        }
      }
      this.kiraanProsedurAi();
      this.kiraanPemeriksaanAi();
    },
   kiraanPemeriksaanAi(){
      const konsutasi_pemeriksaan = this.datas.konsutasi_pemeriksaan ? this.datas.konsutasi_pemeriksaan : 0;
        const caj_pemeriksaan_pd = this.datas.caj_pemeriksaan_pd ? this.datas.caj_pemeriksaan_pd : 0;
        const pengangkutan_pemeriksaan = this.datas.pengangkutan_pemeriksaan ? this.datas.pengangkutan_pemeriksaan : 0;
        const caj_lain_pemeriksaan = this.datas.caj_lain_pemeriksaan ? this.datas.caj_lain_pemeriksaan : 0;
        const keseluruhan_pemeriksaan = this.datas.keseluruhan_pemeriksaan ? this.datas.keseluruhan_pemeriksaan : 0;
      if(this.datas.jenis_pengguna_pemohon == 1){
        this.datas.subsidi_pemeriksaan = 0;
        this.datas.keseluruhan_pemeriksaan = 0;
        if(this.datas.konsutasi_pemeriksaan_ya_tidak==1){ 
          var subsidi_pemeriksaan = Number(pengangkutan_pemeriksaan) + Number(caj_pemeriksaan_pd) + Number(caj_lain_pemeriksaan);
          this.datas.perlu_bayar_pemeriksaan = Number(konsutasi_pemeriksaan);
        }else{
          var subsidi_pemeriksaan = Number(pengangkutan_pemeriksaan) + Number(caj_pemeriksaan_pd) + Number(konsutasi_pemeriksaan) + Number(caj_lain_pemeriksaan);
          this.datas.perlu_bayar_pemeriksaan = 0;
        }
        this.datas.subsidi_pemeriksaan = subsidi_pemeriksaan;
      }else{
        this.datas.keseluruhan_pemeriksaan = 0;
        this.datas.perlu_bayar_pemeriksaan = 0;
        if(this.datas.konsutasi_pemeriksaan_ya_tidak==2){ 
          this.datas.subsidi_pemeriksaan = Number(konsutasi_pemeriksaan);
        }
        this.datas.keseluruhan_pemeriksaan = Number(pengangkutan_pemeriksaan) + Number(caj_lain_pemeriksaan) + Number(caj_pemeriksaan_pd);
        this.datas.perlu_bayar_pemeriksaan = Number(keseluruhan_pemeriksaan);
      }

        this.datas.keseluruhan_pemeriksaan = Number(pengangkutan_pemeriksaan) + Number(konsutasi_pemeriksaan) + Number(caj_pemeriksaan_pd) + Number(caj_lain_pemeriksaan);
      // console.log(datas.perlu_bayar)
    },
    kiraanProsedurAi(){

      var total_harga = 0;

      let ibvk = [];
      ibvk = this.ternakan_list
         .filter((item) => item.lkp_kategori_semen_id === 1)
         .map((item) => ({
           no_batch_keterangan: item.no_batch_keterangan,
           kuantiti: item.bil_straw,
           harga: parseFloat(item.harga_straw),
           total_harga: parseFloat(item.harga_straw) * item.bil_straw,
      }));

      let negri = [];
      negri = this.ternakan_list
         .filter((item) => item.lkp_kategori_semen_id === 2)
         .map((item) => ({
           no_batch_keterangan: item.no_batch_keterangan,
           kuantiti: item.bil_straw,
           harga: parseFloat(item.harga_straw),
           total_harga: parseFloat(item.harga_straw) * item.bil_straw,
      }));

      let persendirian = [];
      persendirian = this.ternakan_list
         .filter((item) => item.lkp_kategori_semen_id === 3)
         .map((item) => ({
           no_batch_keterangan: item.id_ternakan+' | '+item.no_batch,
           kuantiti: item.bil_straw,
           harga: parseFloat(item.harga_straw),
           total_harga: parseFloat(item.harga_straw) * item.bil_straw,
      }));

      const totalIbvk = ibvk.reduce((accumulator, item) => accumulator + item.total_harga, 0);
      const totalNegri = negri.reduce((accumulator, item) => accumulator + item.total_harga, 0);
      const totalPersendirian = persendirian.reduce((accumulator, item) => accumulator + item.total_harga, 0);

    // Output
    console.log('No Batch List:', ibvk);
      var no_batch_keterangan = [];
      for (var b in this.ternakan_list){
        if (this.ternakan_list[b].lkp_kategori_semen_id==1) {
          no_batch_keterangan= this.ternakan_list[b].no_batch_keterangan
        }
      }
      this.ibvk = ibvk;
      this.negri = negri;
      this.persendirian = persendirian;
      this.datas.keseluruhan = Number(this.datas.pengangkutan) + Number(this.datas.konsutasi) + Number(this.datas.caj_lain) + Number(totalIbvk) + Number(totalNegri) + Number(totalPersendirian);
      if(this.datas.jenis_pengguna_pemohon == 1){
         if(this.datas.konsutasi_ya_tidak==2){ 
            var subsidi = Number(totalIbvk) + Number(totalNegri) + Number(this.datas.pengangkutan) + Number(this.datas.konsutasi) + Number(this.datas.caj_lain);
         }else{
            var subsidi = Number(totalIbvk) + Number(totalNegri) + Number(this.datas.pengangkutan) + Number(this.datas.caj_lain);
         }
         this.datas.subsidi = subsidi;
         this.datas.perlu_bayar = this.datas.keseluruhan - subsidi;
      }else{
         if(this.datas.konsutasi_ya_tidak==2){ 
            var subsidi = Number(totalIbvk) + Number(this.datas.konsutasi) + Number(totalNegri);
            // var perlu_bayar = Number(totalPersendirian) + Number(this.datas.caj_lain)+ Number(this.datas.pengangkutan);
         }else{
            var subsidi = Number(totalIbvk) + Number(totalNegri);
            // var perlu_bayar = Number(this.datas.konsutasi) + Number(totalPersendirian) + Number(this.datas.caj_lain)+ Number(this.datas.pengangkutan);
         }
         // this.datas.subsidi = subsidi;
         // this.datas.perlu_bayar = this.datas.keseluruhan - subsidi ;
         if(this.datas.bayar_pengangkutan==2){ 
             var subsidi_pengangkutan =  Number(this.datas.pengangkutan) ;
         }else{
            var subsidi_pengangkutan = 0;
         }

         if(this.datas.bayar_caj_lain==2){ 
             var subsidi_lain =  Number(this.datas.caj_lain) ;
         }else{
            var subsidi_lain = 0;
         }

         this.datas.subsidi = subsidi + subsidi_pengangkutan + subsidi_lain;
         this.datas.perlu_bayar = this.datas.keseluruhan - subsidi -  subsidi_pengangkutan - subsidi_lain;
      }
      // console.log(datas.perlu_bayar)
    },
    lookupStock()
    {
      this.$zcomm.get(this.api_service + 'lookup/stock/1', {}).then(res => {
        this.list_stock = res
      })
    },
   

    validateForm(lkp_status_id) {
      this.loading=true;
      let isValid = true;

      // this.ternakan_list.forEach((row) => {
      //   if (!row.lkp_berahi_id || !row.se_stock_id || !row.bil_straw || !row.skor_badan) {
      //     isValid = false;
      //     this.loading=false;
      //   }
      // });

      if (!isValid) {
        this.$zutil.notify("Pastikan semua data sudah diisi", false);
        this.loading=false;
        return false;
      }
      this.datas.hantar = 1;
      this.onSuccess(lkp_status_id);
    },
    send(hantar){
      this.datas.hantar = hantar
    },

    onSuccess(lkp_status_id){
      this.loading=true;
      this.datas.caj_perkhidmatan = 1;
      if(this.datas.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if (this.datas.id > 0){
                  this.datas.lkp_status_id = lkp_status_id;
                this.$zcomm.update(this.resourceurl + '.update', this.datas.id, this.datas)
                .then(res => {
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  this.loading=false;
                  if (this.form.hantar==1) {
                      // this.$inertia.visit(this.$route('art.permohonan.show', this.datas.id));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
                      this.$inertia.visit(this.$route('art.semakan.index'));
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                })
              }
            }else{
              this.loading=false;
            }
          })
      }else{
        if (this.datas.id > 0) 
        {
          
          this.$zcomm.update(this.resourceurl + '.update', this.datas.id, this.datas,)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            this.loading=false;
            if (this.form.hantar==1) {
                // this.$inertia.visit(this.$route('art.permohonan.show', this.form.id));
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
                      this.$inertia.visit(this.$route('art.semakan.index'));
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
      } 
      
    },
  },
      
  mounted() {
   this.getTernakan();
    // this.datas = this.data;
  }
}
      

</script>  
<style>
.table-aims td{
   padding: 7px;
}
</style>